var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: "Visualizar conflito",
        width: 1000,
        height: 700,
        bodyStyle: { height: "auto", padding: "0" }
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          [
            _c(
              "el-row",
              { staticClass: "row-paddin", attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Número do Processo:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.formatLabel(_vm.conflito.numeroProcesso))
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Nome/Razão Social do Intere:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(
                            _vm.conflito.interessado.nomeRazaoSocial
                          )
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("CPF/CNPJ do Interessado:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(_vm.conflito.interessado.cpfCnpj)
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Município:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(
                            _vm.conflito.municipio
                              ? _vm.conflito.municipio.nome
                              : "-"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Número de Famílias:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.formatLabel(_vm.conflito.numeroFamilias))
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Jurisdição:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(_vm.conflito.jurisdicaoFormatada)
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Data de Cadastro:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(_vm.conflito.dataCriacaoFormatada)
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Data de Atualização:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(_vm.conflito.dataCriacaoFormatada)
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Origem:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.formatLabel(_vm.conflito.origemFormatada))
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Tipo de Processo:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(
                            _vm.conflito.tipoProcesso
                              ? _vm.conflito.tipoProcesso.nome
                              : "-"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Status:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.formatLabel(_vm.conflito.statusFormatado))
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Área/Imóvel/Comunidade:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(_vm.conflito.areaImovelComunidade)
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Setor:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(_vm.formatLabel(_vm.conflito.setor)))
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Possui Georreferenciamento:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatLabel(
                            _vm.conflito.possuiGeorreferenciamento
                              ? "Sim"
                              : "Não"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Descrição:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.formatLabel(_vm.conflito.descricaoCaso))
                      )
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Observação:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(_vm.formatLabel(_vm.conflito.observacao)))
                    ])
                  ]
                ),
                _c(
                  "el-col",
                  { staticClass: "margin-top", attrs: { md: 12, sm: 24 } },
                  [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("Resposta:")
                    ]),
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(_vm.formatLabel(_vm.conflito.resposta)))
                    ])
                  ]
                )
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "row-paddin", attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("span", { staticClass: "info-title" }, [
                    _vm._v("Shape do conflito")
                  ])
                ]),
                _vm.conflito.geometrias && _vm.conflito.geometrias.length > 0
                  ? _c(
                      "el-col",
                      { staticClass: "margin-top", attrs: { span: 24 } },
                      [
                        _c("app-resumo-mapa", {
                          attrs: {
                            idMapa: "id-mapa-localizacao-" + _vm.conflito.id,
                            height: 30,
                            localizacoes: _vm.conflito.geometrias.map(function(
                              g
                            ) {
                              return JSON.parse(g)
                            }),
                            isVisualizarCadastro: true
                          }
                        }),
                        _c("div", { staticClass: "flex-button" }, [
                          _c(
                            "div",
                            { staticClass: "btn" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadShape(_vm.conflito.id)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-download" }),
                                  _vm._v("  Download do shapefile")
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.conflito.possuiGeorreferenciamento
                  ? _c(
                      "el-col",
                      { staticClass: "margin-top", attrs: { span: 24 } },
                      [
                        _c("span", { staticClass: "info-title" }, [
                          _vm._v("Documentos")
                        ]),
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.conflito.documentos,
                              "show-header": false
                            }
                          },
                          [
                            _c("el-table-column", { attrs: { prop: "nome" } }),
                            _c("el-table-column", {
                              attrs: { prop: "tipo.descricao" }
                            }),
                            _c("el-table-column", {
                              attrs: { align: "right", width: "110" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: "Baixar arquivo",
                                              placement: "left"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "button",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.emitDownload(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "download",
                                                    size: "lg"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                339093249
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e961688", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e961688","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ouvidoria/components/ModalVisualizarConflito.vue
// module id = null
// module chunks = 